import { SvgIcon } from '@mui/material';
import SidebarMenuItem from 'components/SidebarMenu/SidebarMenuItem';
import SidebarMenuSection from 'components/SidebarMenu/SidebarMenuSection';
import { ROUTES } from 'constants/routes';
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useNav } from 'utils/navigation';

interface IJITMenuSectionProps {
	open: boolean;
	toggleOpen: () => void;
}

const JITMenuSection: React.FC<IJITMenuSectionProps> = ({
	open,
	toggleOpen
}) => {
	const nav = useNav();
	const location = useLocation();

	return (
		<SidebarMenuSection
			title={intl.tr('scimConfig.guide.jit.pageTitle')}
			open={open}
			onTitleItemClick={toggleOpen}
			startIcon={<SvgIcon fontSize="small" />}
			testIdTopic="jit"
		>
			<SidebarMenuItem
				data-testid="jit-menu-item"
				active={Boolean(matchPath(ROUTES.jit, location.pathname))}
				buttonBaseProps={{ onClick: () => nav(ROUTES.jit) }}
				startIcon={<SvgIcon fontSize="small" />}
			>
				{intl.tr('general.jit')}
			</SidebarMenuItem>
		</SidebarMenuSection>
	);
};

export default JITMenuSection;
